module.exports = __webpack_public_path__ + "static/landscape-stair-concert-a07fa4fa4af114afc63c7da5ce32fe75.jpg";